import React, { useEffect, useState } from "react";
import { Box, Grid, TextareaAutosize, CircularProgress } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import Modal from "../common/modal/Modal";
import ButtonComponent from "../common/button/Button";
import TextInput from "../common/TextInput";
import Dropdown from "../common/Dropdown";
import { postLTSupportTicketEndpoint } from "../../common/endpoints";
import { toast } from "react-toastify";
import { clearSelectedItem } from "../../redux/actions/SupportTicket/selectionSlice";
import { postLTSupportTicket } from "../../redux/actions/LTPlanner/LTSupportTicketSlice";
import allData from "../../common/LTSupportTicket.json";

const Planner = [
    "Action Dashboard",
    "LT Analytics Results & Workflow",
    "S/4 Data-Sync Status",
    "Reports",
    "KPI Tracking",
    "Inventory Impact Simulation"
];
const GMP = [
    "Action Dashboard",
    "LT Analytics Results & Workflow",
    "S/4 Data-Sync Status",
    "Reports",
    "KPI Tracking",
    "Inventory Impact Simulation"
];

const Admin = [
    "Run Analytics & Scheduler",
    "LT Analytics Results & Workflow",
    "Parameter Configuration",
    "Planner Material Mapping",
    "S/4 Data-Sync Status",
    "Reports",
    "KPI Tracking",
    "Inventory Impact Simulation"
];

const Approver = [
    "Approval Management",
    "Reports",
    "KPI Tracking",
    "Inventory Impact Simulation"
];
const Viewer = [
    "LT Analytics Results & Workflow",
    "Reports",
    "KPI Tracking",
    "Inventory Impact Simulation"
];

const roleMenusMap = {
    Planner,
    Admin,
    Approver,
    GMP,
    Viewer
};

const LtTicketModal = (props) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const stateSelector = useSelector((state) => state);
    const [selectedMenu, setSelectedMenu] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [description, setDescription] = useState('');
    const [menuInitialized, setMenuInitialized] = useState(false);
    const [isSubmitClicked, setIsSubmitClicked] = useState(false);

    const [menuOptions, setMenuOptions] = useState([]);
    const [menuAllData, setMenuAllData] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const userEmail = localStorage.getItem("data");

    const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);

    const newCategoryOptions = [
        { label: "Data issue", value: "Data issue", title: "Data issue", },
        { label: "LT computation issue", value: "LT computation issue", title: "LT computation issue", },
        { label: "Other issue", value: "Other issue", title: "Other issue", }
    ];
    const priorityOptions = [
        { label: "Standard", value: "Standard", title: "Standard", },
        { label: "Urgent", value: "Urgent", title: "Urgent", },
    ];

    const [selectedNewCategory, setSelectedNewCategory] = useState("");
    const [selectedPriority, setSelectedPriority] = useState("Standard");
    const newAssignedToOptions = [
        { label: "AL Team", value: "IT: Application - Autonomous Layer", title: "IT: Application - Autonomous Layer", }
    ];

    const [selectedNewAssignedTo, setSelectedNewAssignedTo] = useState("IT: Application - Autonomous Layer");

    useEffect(() => {
        const userRole = localStorage.getItem("LTRole");
        const allowedMenus = roleMenusMap[userRole] || [];
        setMenuAllData(allData?.filter(item => allowedMenus?.includes(item?.menu)))
    }, [location?.pathname])

    useEffect(() => {
        const isMenuValid = selectedMenu;
        const isSubMenuValid = categoryOptions?.length === 0 || selectedCategory;
        const isCategoryValid = selectedNewCategory;
        const isAssignedToValid = selectedNewAssignedTo;
        const isDescription = description
        setIsSubmitEnabled(isMenuValid && isSubMenuValid && isCategoryValid && isAssignedToValid && isDescription);
    }, [selectedMenu, selectedCategory, selectedNewCategory, selectedNewAssignedTo, description, categoryOptions])

    const merged = (
        <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            <div style={{ margin: 10 }}>{description}</div>
            <strong style={{ marginLeft: 10 }}>Selected Items:</strong>
            <div style={{ marginTop: 15, marginLeft: 10, width: '100%' }}>
                <div
                    style={{
                        display: "flex",
                        gap: "12px",
                        fontWeight: "bold",
                        borderBottom: "2px solid #000",
                        paddingBottom: "4px",
                        marginBottom: "6px",
                    }}
                >
                    <div style={{ flex: 1 }}>ID</div>
                    <div style={{ flex: 1 }}>Supplier</div>
                    <div style={{ flex: 1 }}>Material</div>
                    <div style={{ flex: 1 }}>Incoterm Location</div>
                    <div style={{ flex: 1 }}>Plant</div>
                </div>

                {props?.selectedItem?.map((row, index) => (
                    <div
                        key={index}
                        style={{
                            display: "flex",
                            gap: "12px",
                            alignItems: "start",
                            padding: "2px 0",
                            borderBottom: "1px solid #ddd",
                        }}
                    >
                        <div style={{ flex: 1 }}>{row.runOutputSeqId}</div>
                        <div style={{ flex: 1 }}>{row.supplierId}</div>
                        <div style={{ flex: 1 }}>{row.materialId}</div>
                        <div style={{ flex: 1 }}>{row?.incotermLocation ? row?.incotermLocation : row?.shipFrom}</div>
                        <div style={{ flex: 1 }}>{row.plant}</div>
                    </div>
                ))}
            </div>
        </div>
    );


    const getUniqueValues = (data = [], key) => {
        if (data?.length > 0) {
            const uniqueValues = [
                ...new Set(data?.map((item) => item[key]).filter(Boolean)),
            ];
            return uniqueValues?.map((value) => ({
                label: value,
                value: value,
                title: value,
            }));
        } else {
            return [];
        }
    };

    const handleSelectedItemsChange = (name, event) => {
        const value = event.target.value;

        if (name === "menu") {
            setSelectedMenu(value);
            setSelectedCategory("");
            setSelectedNewCategory("");
            dispatch(clearSelectedItem());

            const filteredCategories = menuAllData
                .filter((item) => item.menu === value)
                .map((item) => item.category);
            setCategoryOptions(
                getUniqueValues(
                    filteredCategories?.map((c) => ({ category: c })),
                    "category"
                )
            );
        } else if (name === "category") {
            setSelectedCategory(value);
        }
    };

    useEffect(() => {
        if (!menuInitialized) {
            setSelectedCategory("");
            setDescription("");
            const uniqueMenus = getUniqueValues(menuAllData, "menu");
            setMenuOptions(uniqueMenus);

            const pathToMenuMap = {
                "/analytics-results": "LT Analytics Results & Workflow",
                "/lt-dashboard": "Action Dashboard",
                "/s4datasyncstatus-planner": "S/4 Data-Sync Status",
                "/reports": "Reports",
                "/kpi-tracking": "KPI Tracking",
                "/run-analytics-scheduler": "Run Analytics & Scheduler",
                "/admin-analytics-results": "LT Analytics Results & Workflow",
                "/parameter-configuration": "Parameter Configuration",
                "/planner-material-mapping": "Planner Material Mapping",
                "/s4datasyncstatus": "S/4 Data-Sync Status",
                "/approval-management": "Approval Management",
                "/gmp-dashboard": "Action Dashboard",
                "/gmp-analytics-results": "LT Analytics Results & Workflow",
                "/gmp-s4datasyncstatus": "S/4 Data-Sync Status",
                "/viewer-analytics-results": "LT Analytics Results & Workflow",
                "/inventory-impact-simulation": "Inventory Impact Simulation",
            };

            const matchedMenu = pathToMenuMap[location.pathname];
            if (matchedMenu) {
                setSelectedMenu(matchedMenu);

                const filteredCategories = menuAllData?.filter((item) => item.menu === matchedMenu)
                    .map((item) => item.category);

                const categoryOpts = getUniqueValues(
                    filteredCategories.map((c) => ({ category: c })),
                    "category"
                );
                setCategoryOptions(categoryOpts);
            }

            setMenuInitialized(true);
        }
        setMenuInitialized(false);
    }, [location.pathname, menuAllData, menuInitialized]);

    const handleCategoryChange = (e) => {
        setSelectedNewCategory(e.target.value)
    }
    const handlePriorityChange = (e) => {
        setSelectedPriority(e.target.value)
    }
    const handleNewAssignedTo = (e) => {
        setSelectedNewAssignedTo(e.target.value)
    }

    const submitTicketHandler = () => {
        setIsSubmitClicked(true)
    }
    const onClickBack = () => {
        setIsSubmitClicked(false);
        setSuccessMessage("")
    }
    const onClickCancel = () => {
        onClickBack()
        props.handleClose();
    }

    const createTicketAPI = async () => {
        const itemsHtml = props?.selectedItem
            ?.map(
                (row) => `
      <tr>
        <td>${row.runOutputSeqId}</td>
        <td>${row.supplierId}</td>
        <td>${row.materialId}</td>
        <td>${row?.incotermLocation ? row?.incotermLocation : row?.shipFrom}</td>
        <td>${row.plant}</td>
      </tr>`
            )
            .join("");

        const issueDescription =
            props?.selectedItem?.length > 0
                ? `${description}<br/><br/>Selected Items:<br/>
      <table border="1" cellspacing="0" cellpadding="4" style="width:100%; table-layout:fixed; border-collapse:collapse; text-align:center;">
        <tr>
          <th style="width:20%;">ID</th>
          <th style="width:20%;">Supplier</th>
          <th style="width:20%;">Material</th>
          <th style="width:20%;">Location</th>
          <th style="width:20%;">Plant</th>
        </tr>
        ${itemsHtml}
      </table>`
                : description;

        const supportTicketRequestBody = {
            userEmail: userEmail,
            menu: selectedMenu,
            submenu: selectedCategory ? selectedCategory : selectedMenu,
            category: selectedNewCategory,
            urgency: selectedPriority,
            issueDescription: issueDescription,
            assignedTo: selectedNewAssignedTo,
        };

        try {
            const responseSupportTicket = await dispatch(postLTSupportTicket({
                dynamicEndpoint: `${postLTSupportTicketEndpoint}`,
                data: supportTicketRequestBody,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                }
            }));
            if (responseSupportTicket.meta.requestStatus === 'fulfilled') {
                dispatch(clearSelectedItem());
                setSuccessMessage(responseSupportTicket?.payload)
            } else {
                toast.error(responseSupportTicket?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error(error, {
                autoClose: 2000,
            });
        }
    }

    return (
        <Modal
            open={props.showModal}
            handleClose={onClickCancel}
            title={props.title}
            fullWidth={true}
            maxWidth="md"
            content={
                <>
                    {successMessage?.length > 0 ?
                        <div>
                            <span>{successMessage}</span>
                        </div>
                        :
                        !isSubmitClicked && successMessage?.length === 0 ?
                            <>
                                <Grid container spacing={2}>
                                    <Grid
                                        item
                                        xs={12}
                                        md={2.5}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <label className="label-position" htmlFor="hierarchy">
                                            Menu
                                        </label>
                                        <Dropdown
                                            maxWidth="100%"
                                            // label="Menu"
                                            value={selectedMenu || ""}
                                            name="menu"
                                            options={menuOptions}
                                            handleChange={(event) =>
                                                handleSelectedItemsChange("menu", event)
                                            }
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        md={2.5}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <label className="label-position" htmlFor="hierarchy">
                                            Sub Menu
                                        </label>
                                        <Dropdown
                                            maxWidth="100%"
                                            // label="Sub Menu"
                                            value={selectedCategory || ""}
                                            name="category"
                                            options={categoryOptions}
                                            handleChange={(event) =>
                                                handleSelectedItemsChange("category", event)
                                            }
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        md={2.5}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <label className="label-position" htmlFor="hierarchy">
                                            Category
                                        </label>
                                        <Dropdown
                                            maxWidth="100%"
                                            // label="Category"
                                            value={selectedNewCategory || ""}
                                            name="function"
                                            options={newCategoryOptions}
                                            handleChange={(event) =>
                                                handleCategoryChange(event)
                                            }
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        md={2.5}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <label className="label-position" htmlFor="hierarchy">
                                            Priority
                                        </label>
                                        <Dropdown
                                            maxWidth="100%"
                                            // label="Category"
                                            value={selectedPriority || ""}
                                            name="function"
                                            options={priorityOptions}
                                            handleChange={(event) =>
                                                handlePriorityChange(event)
                                            }
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        md={2}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <label className="label-position" htmlFor="hierarchy">
                                            Assigned to
                                        </label>
                                        <Dropdown
                                            maxWidth="100%"
                                            // label="Assigned to"
                                            value={selectedNewAssignedTo || ""}
                                            name="assignedTo"
                                            options={newAssignedToOptions}
                                            handleChange={(event) =>
                                                handleNewAssignedTo(event)
                                            }
                                        />
                                    </Grid>
                                </Grid>
                                {
                                    props?.selectedItem?.length > 0 &&
                                    <div style={{ margin: '10px 0px', border: '1px solid #bcbcbc', fontSize: 12 }}>
                                        <div style={{ display: 'flex', borderBottom: '1px solid #bcbcbc', marginRight: props?.selectedItem?.length > 2 ? 15 : 0, padding: '0px 10px' }}>
                                            <p style={{ width: 100, fontWeight: 'bold' }}>ID</p>
                                            <p style={{ width: 200, fontWeight: 'bold' }}>Supplier</p>
                                            <p style={{ width: 200, fontWeight: 'bold' }}>Material</p>
                                            <p style={{ width: 200, fontWeight: 'bold' }}>Incoterm Location</p>
                                            <p style={{ width: 200, fontWeight: 'bold' }}>Plant</p>
                                        </div>
                                        <div style={{ height: '80px', overflowY: 'auto', padding: '0px 10px' }}>
                                            {
                                                props?.selectedItem?.map((item, index) =>
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: 100 }}>{item?.runOutputSeqId}</p>
                                                        <p style={{ width: 200 }}>{item?.supplierId}</p>
                                                        <p style={{ width: 200 }}>{item?.materialId}</p>
                                                        <p style={{ width: 200 }}>{item?.incotermLocation ? item?.incotermLocation : item?.shipFrom}</p>
                                                        <p style={{ width: 200 }}>{item?.plant}</p>
                                                    </div>
                                                )
                                            }

                                        </div>

                                    </div>
                                }
                                <Grid mt={2}>
                                    <TextareaAutosize
                                        minRows={6}
                                        placeholder="Issue Description"
                                        style={{ width: '100%' }}
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                </Grid>
                            </>
                            :
                            <>
                                <div>
                                    <p>Preview</p>
                                    <div style={{ border: '1px solid #bcbcbc', padding: 10, }}>
                                        {selectedMenu &&
                                            <div style={{ display: 'flex', margin: '10px 0px' }}>
                                                <b style={{ width: '25%' }}>Menu </b>
                                                <span style={{ width: '70%' }}>: {selectedMenu}</span>
                                            </div>
                                        }
                                        {selectedCategory &&
                                            <div style={{ display: 'flex', margin: '10px 0px' }}>
                                                <b style={{ width: '25%' }}>Sub Menu</b>
                                                <span style={{ width: '70%' }}>: {selectedCategory}</span>
                                            </div>
                                        }
                                        {selectedNewCategory &&
                                            <div style={{ display: 'flex', margin: '10px 0px' }}>
                                                <b style={{ width: '25%' }}>Category</b>
                                                <span style={{ width: '70%' }}>: {selectedNewCategory}</span>
                                            </div>
                                        }
                                        {selectedPriority &&
                                            <div style={{ display: 'flex', margin: '10px 0px' }}>
                                                <b style={{ width: '25%' }}>Priority</b>
                                                <span style={{ width: '70%' }}>: {selectedPriority}</span>
                                            </div>
                                        }
                                        {selectedNewAssignedTo &&
                                            <div style={{ display: 'flex', margin: '10px 0px' }}>
                                                <b style={{ width: '25%' }}>Assigned To </b>
                                                <span style={{ width: '70%' }}>: {selectedNewAssignedTo}</span>
                                            </div>
                                        }
                                        {description &&
                                            <div style={{ display: 'flex', margin: '10px 0px' }}>
                                                <b style={{ width: '25%' }}>Issue Description </b>
                                                <span style={{ width: '70%' }}>:  {props?.selectedItem?.length > 0 ? <span><span style={{ fontWeight: 'bold' }}>User Remarks</span> <span> {merged}</span></span> : description}</span>
                                            </div>
                                        }
                                    </div>
                                </div>

                            </>

                    }
                </>
            }
            action={
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        margin: "15px 0",
                    }}
                >
                    <div>
                        {
                            successMessage?.length === 0 && <TextInput
                                label="Initiator"
                                value={props.userEmail}
                                disabled={true}
                            />
                        }
                    </div>
                    {
                        successMessage?.length > 0 ?
                            <ButtonComponent
                                maxWidth="150px"
                                label="Close"
                                bgColor="white"
                                color="black"
                                onClick={onClickCancel}
                            />
                            :
                            <div
                                style={{
                                    display: "flex",
                                    gap: 10,
                                    justifyContent: 'end',
                                    width: "300px",
                                    alignItems: "center",
                                }}
                            >
                                {!isSubmitClicked && successMessage?.length === 0 ?
                                    <ButtonComponent
                                        maxWidth="150px"
                                        label="Cancel"
                                        bgColor="white"
                                        color="black"
                                        onClick={onClickCancel}
                                    />
                                    :
                                    stateSelector?.LTSupportTicketSlice?.loading ?
                                        <></>
                                        :
                                        <ButtonComponent
                                            maxWidth="150px"
                                            label="Back"
                                            bgColor="white"
                                            color="black"
                                            onClick={onClickBack}
                                        />
                                }
                                {!isSubmitClicked && successMessage?.length === 0 ?
                                    <ButtonComponent
                                        maxWidth="150px"
                                        label="Submit"
                                        bgColor="black"
                                        color="white"
                                        onClick={submitTicketHandler}
                                        disabled={!isSubmitEnabled}
                                    />
                                    :
                                    stateSelector?.LTSupportTicketSlice?.loading ?
                                        <Box style={{ textAlign: 'center' }}>
                                            <CircularProgress color="inherit" style={{ width: '20px', height: '20px', textAlign: 'center', marginRight: 30 }} />
                                        </Box>
                                        :
                                        <ButtonComponent
                                            maxWidth="250px"
                                            label="Create Ticket"
                                            bgColor="black"
                                            color="white"
                                            onClick={createTicketAPI}
                                        />
                                }
                            </div>
                    }
                </div>
            }
        />
    );
};

export default LtTicketModal;
